import React, { useState, useEffect, useContext } from 'react'
import { PlayerContext } from '../../../../Context'
import { PlayerDataGQL } from '../../../../Api'
import { mapInjuryStatus } from '../../../../Utils'
import { InjuryTableCon } from './styles'
import { TableHeader } from '../../../../Components/Tables/TableHeader'

export const TeamInjury: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { isRosterLoading, roster  } = useContext(PlayerContext)!
  const [injuries, setInjuries] = useState<PlayerDataGQL[]>([])

  useEffect(() => {
    if (roster.length < 1) return
      const filtered = roster.filter(
        (pl) =>
          pl.currentTeam?.injuryStatus !== null &&
          pl.currentTeam?.injuryStatus?.toLowerCase() !== 'h' &&
          pl.currentTeam?.injuryStatus?.toLowerCase() !== 'na'
      )
      setInjuries(filtered)
  }, [isRosterLoading])

  return (
    <InjuryTableCon>
      <table className='table'>
      <thead>
        <tr>
          <TableHeader ariaLabel="Player">Player</TableHeader>
          <TableHeader ariaLabel="Status">Status</TableHeader>
          <TableHeader ariaLabel="Description">Description</TableHeader>
        </tr>
      </thead>
      {injuries.length < 1 && <div>No Injuries</div>}
      {injuries.length >= 1 && (
        <>
          <tbody>
            {injuries.map((pl, idx) => (
              <tr key={idx}>
                <td>
                  {pl.firstName} {pl.lastName} | {pl.currentTeam.position}
                </td>
                <td>{mapInjuryStatus(pl.currentTeam.injuryStatus || '')}</td>
                <td>{pl.currentTeam.injuryDescription}</td>
              </tr>
            ))}
          </tbody>
        </>
      )}
      </table>
    </InjuryTableCon>
  )
}
